export default __webpack_public_path__ + "static/BannerProduct-73816f069c6b9b8108eac72cb59dc7a8.jpg";